/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import "./Card.css";
import { useNavigate } from "react-router-dom";

const Card = ({ data }) => {
  const navigate = useNavigate();

  return (
    <>
      <div className="">
        <div className="row">
          <div className="col-lg-6">
            <div className="">
              <div className="blog-slider">
                <div className="blog-slider__title">{data?.make}</div>
                <div className="blog-slider__img">
                  <img src={data?.link_img_hd[0]} alt="" />
                </div>
                <div className="blog-slider__content">
                  <div className="row justify-content-center mb-4">
                    <div className="col-md-4 px-0">
                      <h6 className="lh-xl">Model year:</h6>
                      <h6 className="lh-xl">Lot #:</h6>
                      <h6 className="lh-xl">Location:</h6>
                    </div>
                    <div className="col-md-4 px-0">
                      <h6 className="lh-xl">{data?.model}</h6>
                      <h6 className="lh-xl">{data?.year}</h6>
                      <h6 className="lh-lg fs-6">{data?.lot_id}</h6>
                      <h6 className="lh-lg fs-6 mt-1">{data?.location}</h6>
                    </div>
                  </div>
                  <p className="fs-6 text-dark">
                    Current Bid {data?.current_bid}
                  </p>
                  <button
                    className="theme-btn mt-3"
                    onClick={() =>
                      navigate(
                        `/detail/${data?.id}`,
                        { state: { data } },
                        window.scrollTo(0, 0)
                      )
                    }
                  >
                    Order Now
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Card;
